import {
  Box,
  Button,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import BreadCrumbs from "../../components/Breadcrumbs";
import { useState } from "react";
import {getTheme} from "../../styles/theme";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import StyledTitleDot from "../../components/common/StyledTitleDot";

export default function ResidenceChange() {
  const initialState = {
    roomNumber: "",
    invoiceNo: "",
    receiveOffer: "",
    reason: "",
    notes: "",
    evidence: "",
  };

  const [formValues, setFormValues] = useState(initialState);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  return (
    <>
      <Typography className="title" variant="h4">
        Residence Change
        <StyledTitleDot />
      </Typography>
      <BreadCrumbs routs={["Residence Change"]} />
      <Container
        maxWidth={false}
        sx={{
          width: { xs: "100%", md: "70vw", lg: "54vw" },
          padding: "0 !important",
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontSize: "27px",
            fontWeight: "700",
            marginTop: "3rem",
            textAlign: "center",
          }}
          color={getTheme().palette.secondary.main}
        >
          Place Your Request
        </Typography>
        <Grid container spacing={3} sx={{ marginTop: ".5rem" }}>
          <Grid item xs={12} sm={6}>
            <TextField
              sx={{
                width: "100%",
              }}
              value={formValues.roomNumber}
              onChange={handleChange}
              name="roomNumber"
              id="outlined-basic"
              label="Current Residence / Room Number"
              variant="outlined"
              type="text"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              sx={{
                width: "100%",
              }}
              value={formValues.invoiceNo}
              onChange={handleChange}
              name="invoiceNo"
              id="outlined-basic"
              label="Invoice No"
              variant="outlined"
              type="text"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel
                    sx={{ maxWidth: "calc(100% - 40px)" }}
                    id="receiveOffer"
                  >
                    Which residences you wish to receive offer (subject to
                    availability and additional prices may impact as per t&c)
                  </InputLabel>
                  <Select
                    name="receiveOffer"
                    labelId="receiveOffer"
                    id="demo-simple-select"
                    value={formValues.receiveOffer}
                    label="Which residences you wish to receive offer (subject to availability and additional prices may impact as per t&c)"
                    onChange={handleChange}
                  >
                    <MenuItem value={"1"}>Lorem Ipsum</MenuItem>
                    <MenuItem value={"2"}>Lorem Ipsum</MenuItem>
                    <MenuItem value={"3"}>Lorem Ipsum</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel
                    sx={{ maxWidth: "calc(100% - 40px)" }}
                    id="reason"
                  >
                    Reason Of The Room Change*
                  </InputLabel>
                  <Select
                    name="reason"
                    labelId="reason"
                    id="reason"
                    value={formValues.reason}
                    label="Reason Of The Room Change*"
                    onChange={handleChange}
                  >
                    <MenuItem value={"cleaningIssues"}>
                      Cleaning Issues
                    </MenuItem>
                    <MenuItem value={"wifIsSlow"}>Wifi Is Slow</MenuItem>
                    <MenuItem value={"HeaterIsNotWorking"}>
                      Heater Is Not Working
                    </MenuItem>
                    <MenuItem value={"fridgeIsBroken"}>
                      Fridge Is Broken
                    </MenuItem>
                    <MenuItem value={"other"}>Other</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              sx={{
                width: "100%",
                height: "100%",
              }}
              value={formValues.notes}
              onChange={handleChange}
              name="notes"
              id="outlined-basic"
              label="Notes"
              variant="outlined"
              type="text"
              multiline // This enables the textarea feature
              InputProps={{
                inputProps: {
                  style: {
                    height: "100%",
                    boxSizing: "border-box", // Padding ve border dahil olmak üzere yüksekliğin hesaplanmasını sağlar
                  },
                },
                style: {
                  // Bu, dış div'e stil verir
                  height: "100%",
                  overflow: "hidden", // Eğer içerik kutudan taşarsa gizler
                },
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                height: "100%",
              }}
            >
              <Typography variant="body1">
                If Any Evidence/Proof Please Attach
              </Typography>
              <Button
                sx={{
                  height: "100%",
                }}
                variant="contained"
                component="label"
                startIcon={<CloudUploadIcon />}
              >
                Upload
                <input type="file" hidden />
              </Button>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Button
              variant="contained"
              color="primary"
              sx={{
                height: "100%",
                display: "block",
                minHeight: "56px",
                width: "100%",
              }}
            >
              SUBMIT
            </Button>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
